export const SET_TOURNAMENT_ID = 'SET_TOURNAMENT_ID';
export const SET_RETURNING_TO_CALENDAR = 'SET_RETURNING_TO_CALENDAR';



// WEBPACK FOOTER //
// ./src/features/registration/constants.js